import { useCallback } from 'react'
import get from 'lodash/get'
import {
  AccountSelectionBuilder,
  DataSelectionBuilder,
  FieldMappingBuilder,
  IntegrationFormField,
  IntegrationFormManager,
  IntegrationNameBuilder,
} from '../components'
import { INTEGRATION_TYPE, DATA_TYPE_KEY, DATA_TYPES } from './components/constants'

export function TikTokOutbound({ assignment }) {
  const assignmentMetaDataType = assignment.metadata[DATA_TYPE_KEY] || DATA_TYPES[0].type

  const integrationFieldsFilter = useCallback(
    field =>
      get(field, 'fieldTypes', [])
        .map(row => row.type)
        .includes(assignmentMetaDataType),
    [assignmentMetaDataType],
  )

  const integrationNameField = new IntegrationNameBuilder().build()
  const accountSelectionField = new AccountSelectionBuilder()
    .resetOnChange(true)
    .dataType(assignmentMetaDataType)
    .build()
  const dataSelectionField = new DataSelectionBuilder()
    .placement(2)
    .dataOptions(DATA_TYPES)
    .defaultValue(DATA_TYPES[0].type)
    .metadataKey(DATA_TYPE_KEY)
    .resetIntegrationOnChange(true)
    .build()
  const fieldMapping = new FieldMappingBuilder()
    .placement(5)
    .integrationTitle('TikTok')
    .integrationFieldsFilter(integrationFieldsFilter)
    .dataType(assignmentMetaDataType)
    .mappingType('outbound')
    .build()

  const formFields: IntegrationFormField[] = [
    accountSelectionField,
    dataSelectionField,
    fieldMapping,
    integrationNameField,
  ]

  return (
    <div style={{ width: '100%' }}>
      <IntegrationFormManager
        integrationType={INTEGRATION_TYPE}
        integrationAssignment={assignment}
        integrationFields={formFields}
        assignmentMetaDataType={assignmentMetaDataType}
      />
    </div>
  )
}
